<template>
  <div></div>
</template>

<script>
export default {
  name: "SiteName",
  props: ["member_link"],
  inject: ['updateSiteInfo'],
  data() {
    const root = process.env.VUE_APP_API;
    return {
      siteName: "REECH",
      siteUrl: "",
      termsOfUseUrl: "https://reech.co.jp/term/",
      oemAPI: root + "/api/auth/oem",
    };
  },
  async mounted() {
    await this.fetchFromSiteInfo();
  },
  methods: {
    async fetchFromSiteInfo() {
      if (this.member_link) {
        try {
          var params = new URLSearchParams();
          params.append("member_link", this.member_link);
          const response = await this.axios.post(this.oemAPI, params);

          if (response && response.data && response.data.oem) {
            if(response.data.oem.site_name && response.data.oem.site_name.trim() !== '') {
              this.siteName = response.data.oem.site_name;
            }
            if(response.data.oem.site_url && response.data.oem.site_url.trim() !== '') {
              this.siteUrl = response.data.oem.site_url;
            }
            if(response.data.oem.terms_of_use_url && response.data.oem.terms_of_use_url.trim() !== '') {
              this.termsOfUseUrl = response.data.oem.terms_of_use_url;
            }
            this.$emit('updateSiteInfo', {siteName: this.siteName, siteUrl: this.siteUrl, termsOfUseUrl: this.termsOfUseUrl});
          }
        } catch (error) {
          console.error("タイトルの取得中にエラーが発生しました", error);
        }
      }
    },
  },
};
</script>